import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import _ from 'lodash/string';

import Header from './components/common/Header';
import Footer from './components/common/Footer';
import MainPage from './components/page/MainPage';
import ContactPage from './components/page/ContactPage';
import AboutUsPage from "./components/page/AboutUsPage";
import ProductPage from './components/page/ProductPage';
import ArchivePage from './components/page/ArchivePage';
import ProductDetailsPage from './components/page/ProductDetailsPage';
import SupportPage from "./components/page/SupportPage";
import NoMatch from './components/error/NoMatch';
import SVG from './components/common/SVG';
import CTABar from './components/common/CTABar';

import navs from './config/navs';
import pages from './config/pages';
import api from './config/api';
import {completeUrls, getPageClassOfItemByCode} from './util/utils';
import SecuriForumPage from "./components/page/SecuriForumPage";
import SearchPage from "./components/page/SearchPage";
import FAQPage from "./components/page/FAQPage";
import CookieAccept from "./components/common/CookieAccept";
import ArticleDetailsPage from "./components/page/ArticleDetailsPage";
import ArticlePage from "./components/page/ArticlePage";
import CameraWorkshopPage from "./components/landing/CameraWorkshopPage";
import SmartHomeWorkshopPage from "./components/landing/SmartHomeWorkshopPage";
import WebshopLandingPage from "./components/landing/WebshopLandingPage";
import ProductMultiPage from "./components/page/ProductMultiPage";
import AppPage from './components/page/AppPage';
import EuProjectPage from './components/page/EUProjectPage';
import CCAMPage from './components/page/CCAMPage';

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
			query: '',
			search: [],
			pages: {},
			navs: {},
			flatNavs: [],
			routes: []
		};
	}

	componentWillMount() {
		this.loadPages();
		this.loadNavs();
		this.loadFlattenNavs();
		this.locationChangeListener();
	}

	loadProductsByQuery = () => {
		fetch(api.query(this.state.query,this.props.selectedLanguage.codeCountry))
			.then(res => res.json())
			.then(data => {
				this.setState({search: completeUrls(data)});
			}).catch(err => console.error(err));
	};

	loadPages = () => {
		this.setState({pages: pages});
	};

	loadNavs = () => {
		this.setState({navs: navs});
	};

	loadFlattenNavs = () => {
		const items = navs.mainNav.items;
		const flatNavs = [];
		items.forEach(item => {
			const subItems = item.subItems.map(subItem => {
				subItem.multiple = subItem.subItems.length > 0;
				return subItem;
			});
			// item.subItems = [];
			item.multiple = subItems.length > 0;
			flatNavs.push(item, ...subItems);
		});
		this.setState({flatNavs});
	};

	/**
	 * Listen location change
	 */
	locationChangeListener = () => {
		this.props.history.listen((location,action)=>{
			document.querySelector('.main-nav-button').classList.remove('main-nav-button--open');
			document.querySelector('.main-nav-mobile').classList.remove('main-nav-mobile--open');
			window.scrollTo(0,0);
		});
	};

	/**
	 * Set the query state
	 *
	 * @param query {String} - keyword or keywords for search
	 */
	setQuery = (query) => {
		this.setState({query});
	};

	/**
	 * Redirect to the search result page
	 *
	 * @returns {XML}
	 */
	search = () => {
		const url = this.localizePath('/search/').concat(_.kebabCase(this.state.query));
		return this.props.history.push(url);
	};

	/**
	 * Render CTA Bar
	 */
	renderCTAbar = (path) => {
		return (
			<Route path={path} key={path} render={props => (
				<CTABar
					ctaText="Are you interested in other products? (SET-TOP BOX)"
					ctaLink="http://amikostb.com/"
					ctaButtonText="Click Here!"
				/>
			)}/>
		);
	};

	/**
	 * Render ProductPageRoutes
	 */
	renderProductPageRoutes = (item) => {
		if(['/support','/contact-us','/about-us','/archive'].includes(item.linkTo)){
			return null;
		}

		return (
			<Route path={this.localizePath(item.linkTo)} key={this.localizePath(item.linkTo)}
			       exact={item.exact} strict={item.strict}
			       render={ (props) => this.renderProductPageBySubItems(props,item,item.multiple) } />
		);
	};

	/**
	 * Render multiple or single component of the product route
	 * rely on the product multiple attribute
	 * @param props
	 * @param item
	 * @param multiple
	 * @returns {*}
	 */
	renderProductPageBySubItems = (props, item, multiple) => {
		const {selectedLanguage} = this.props;

		if(multiple){
			return (
				<ProductMultiPage
					title={item.name}
					code={item.code}
					banner={getPageClassOfItemByCode(item.code)}
					categories={item.subItems.map(category => category.code)}
					selectedLanguage={selectedLanguage}
					localizePath={this.localizePath}
					getQuery={this.state.query}
					setQuery={this.setQuery}
					search={this.search}
					{...props} />
			);
		}

		return (
			<ProductPage
				title={item.name}
				code={item.code}
				banner={getPageClassOfItemByCode(item.code)}
				selectedLanguage={selectedLanguage}
				localizePath={this.localizePath}
				getQuery={this.state.query}
				setQuery={this.setQuery}
				search={this.search}
				{...props} />
		);
	};

	/**
	 * Create localized route path based on selected language
	 * @param path
	 * @returns {string}
	 */
	localizePath = (path) => {
		const {selectedLanguage,defaultLanguage} = this.props;
		return selectedLanguage.id === defaultLanguage.id
			? path
			: path === '/'
				? '/' + selectedLanguage.code
				: '/' + selectedLanguage.code + path;
	};

	render() {

		const {changeLanguage,selectedLanguage,availableLanguages,defaultLanguage,location,history} = this.props;

		return (
			<div className="amikohome">
				<SVG/>
				<CookieAccept/>
				<Header
					mainNav={this.state.navs.mainNav}
					changeLanguage={changeLanguage}
					availableLanguages={availableLanguages}
					selectedLanguage={selectedLanguage}
					defaultLanguage={defaultLanguage}
					location={location}
					history={history}
					localizePath={this.localizePath}
				/>
				<main className="main-content">
					<Switch>
						<Route exact path={this.localizePath('/')} render={ (props) => (
							<MainPage
								page={this.state.pages.main}
								selectedLanguage={selectedLanguage}
								localizePath={this.localizePath}
								setHasSlider={this.setHasSlider}
								getQuery={this.state.query}
								setQuery={this.setQuery}
								search={this.search}
								{...props}
							/>
						)}/>
						{this.state.flatNavs.map(this.renderProductPageRoutes)}
						<Route path={this.localizePath('/archive')} render={ (props) => (
							<ArchivePage
								page={this.state.pages.archive}
								selectedLanguage={selectedLanguage}
								localizePath={this.localizePath}
								{...props}
							/>
						)}/>
						<Route path={this.localizePath('/search/:query')} render={ (props) => (
							<SearchPage
								page={this.state.pages.search}
								products={this.state.search}
								loadProducts={this.loadProductsByQuery}
								selectedLanguage={selectedLanguage}
								localizePath={this.localizePath}
								{...props}
							/>
						)}/>
						<Route path={this.localizePath('/about-us')} render={ (props) => (
							<AboutUsPage
								page={this.state.pages.aboutUs}
								selectedLanguage={selectedLanguage}
								{...props}
							/>
						)}/>
						<Route path={this.localizePath('/faq')} render={ (props) => (
							<FAQPage
								page={this.state.pages.faq}
								selectedLanguage={selectedLanguage}
								{...props}
							/>
						)}/>
						<Route path={this.localizePath('/support')} render={ (props) => (
							<SupportPage
								page={this.state.pages.support}
								selectedLanguage={selectedLanguage}
								{...props}
							/>
						)}/>
						<Route path={this.localizePath('/contact-us')} render={ (props) => (
							<ContactPage
								selectedLanguage={selectedLanguage}
								page={this.state.pages.contactUs}
								{...props}
							/>
						)}/>
						<Route path={this.localizePath('/product/:productUrl')} render={ (props) => (
							<ProductDetailsPage
								selectedLanguage={selectedLanguage}
								localizePath={this.localizePath}
								getQuery={this.state.query}
								setQuery={this.setQuery}
								search={this.search}
								navs={this.state.navs}
								{...props}
							/>
						)}/>
						<Route path={this.localizePath('/article/:articleUrl')} render={ (props) => (
							<ArticleDetailsPage
								selectedLanguage={selectedLanguage}
								localizePath={this.localizePath}
								navs={this.state.navs}
								{...props}
							/>
						)}/>
						<Route path={this.localizePath('/articles')} render={ (props) => (
							<ArticlePage
								selectedLanguage={selectedLanguage}
								localizePath={this.localizePath}
								navs={this.state.navs}
								{...props}
							/>
						)}/>
						<Route path={this.localizePath('/securiforum')} render={ (props) => (
							<SecuriForumPage {...props} />
						)}/>
						<Route path={this.localizePath('/kameraworkshop')} render={ (props) => (
							<CameraWorkshopPage {...props} />
						)}/>
						<Route path={this.localizePath('/okosotthonworkshop')} render={ (props) => (
							<SmartHomeWorkshopPage {...props} />
						)}/>
						<Route path={this.localizePath('/markabolt')} render={ (props) => (
							<WebshopLandingPage {...props} />
						)}/>
						<Route path={[this.localizePath('/nyertespalyazat_erfa'), '/nyertespalyazat_erfa']} render={ (props) => (
							<EuProjectPage {...props} />
						)}/>
						<Route path={[this.localizePath('/downloads/smartlock'), this.localizePath('/mobileapps')]} render={ (props) => (
							<AppPage {...props} />
						)}/>
						<Route path={this.localizePath('/ccam')} render={ (props) => (
							<CCAMPage {...props} />
						)}/>
						<Route render={ (props) => (
							<NoMatch
								localizePath={this.localizePath}
								{...props} />
						)}/>
					</Switch>
				</main>
				{['/about-us', '/contact-us']
					.map(this.localizePath)
					.map(this.renderCTAbar)}
				<Footer
					localizePath={this.localizePath}
					selectedLanguage={selectedLanguage} />
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js